src/components/Post.vue
<template>
  <div>
    <div class="post" v-if="start&!aleady">
      <a id="back" @click="back()">戻る</a>
      <br />
      <h2>応募フォーム</h2>
      <div class="textbox" v-if="!posted">
        <select v-model="Form.department">
          <option disabled value>部門</option>
          <option>中学生の部</option>
          <option>高等学校の部</option>
          <option>高等教育機関(大学等)以上の部</option>
        </select>
        <input class="texts" type="text" maxlength="30" placeholder="ペンネーム" v-model="Form.name" />
        <input class="texts" type="text" maxlength="100" placeholder="タイトル" v-model="Form.title" />
        <div>
          タグを選択してください。
          <br />（R15を除き、ネタバレになるようなタグはつけなくてもかまいません）
          <br />
          <span v-for="(tag, i) in tags" :key="i" class="tag">
            <input :id="'tag' + i" type="checkbox" :value="tag" v-model="Form.serectTags" />
            <label :id="'label' + i" :for="'tag' + i">{{tag}}</label>
          </span>
        </div>
        <textarea
          id="intro"
          class="texts"
          maxlength="150"
          placeholder="紹介(120文字以内)"
          v-bind:class="{'alert-color': (intro_count>120) }"
          v-model="Form.intro"
          @input="introChange"
        />
        <p class="counts" v-bind:class="{'alert-color': (intro_count>120) }">{{intro_count}}文字</p>
        <textarea
          id="body"
          class="texts"
          maxlength="11000"
          placeholder="本文(10000文字以内)"
          v-model="Form.body"
          @input="bodyChange"
          v-bind:class="{'alert-color': (body_count>10000) }"
        />
        <p
          class="counts"
          v-bind:class="{'alert-color': (body_count>10000||body_count<400) }"
        >{{body_count }}文字</p>
        <textarea
          id="bikou"
          class="texts"
          maxlength="500"
          placeholder="必要であれば備考欄(500文字以内)"
          v-model="Form.bikou"
          @input="bodyChange"
          v-bind:class="{'alert-color': (Form.bikou.length>500) }"
        />
        <div>投稿後の変更は出来ませんので今一度確認をお願いします</div>
        <span class="tag">
          <input type="checkbox" id="checkbox" v-model="kakunin" />
          <label for="checkbox" class="zyuuyou">確認しました</label>
        </span>
        <div v-if="kakunin">
          <button @click="post" v-if="!loading">応募</button>
          <button v-else disabled>応募中</button>
        </div>
        <div v-else class="zyuuyou">
          <br />チェックボタンを押してください
          <br />
        </div>
        <div v-if="error">すみません、エラーが発生しました。時間を開けて再度お願いします。</div>
      </div>
      <div class="posted" v-else>
        <div>応募完了しました。</div>
        <router-link to="/">ホームに戻る</router-link>
      </div>
    </div>
    <div v-if="!start">
      <a id="back" @click="back()">戻る</a>
      <br />
      <div class="box">
        応募は終了しております。たくさんのご応募ありがとうございました。
        現在審査を行っております。受賞作の発表ならびに感想の連絡は5/25（月）を予定しておりますが、
        状況により延長される場合があります。
        ご了承ください。なお、審査期間でも作品の閲覧は可能ですのでぜひご覧ください。
      </div>
    </div>
    <div v-if="aleady">
      <a id="back" @click="back()">戻る</a>
      <br />
      <h2>
        <span class="tag">投票済みです</span>
        <span class="tag">結果発表までしばらくお待ちください</span>
      </h2>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
//import firebase from "firebase";

export default {
  name: "Post",
  data: () => ({
    start: false,
    aleady: false,
    kakunin: false,
    Form: {
      spotName: "コロナ01",
      department: "",
      title: "",
      intro: "",
      body: "",
      name: "",
      bikou: "",
      serectTags: []
    },
    snackBar: {
      show: false,
      color: "",
      message: ""
    },
    tags: [
      "R15",
      "男主人公",
      "女主人公",
      "人外",
      "ファンタジー",
      "過去",
      "現代",
      "未来",
      "ハーレム",
      "群像劇",
      "青春",
      "コメディ"
    ],
    intro_count: 0,
    body_count: 0,
    loading: false,
    posted: false,
    error: false
  }),
  created() {
    // view が作られた時にデータを取得し、
    // そのデータは既に監視されています
    this.fetchData();
  },
  watch: {
    // ルートが変更されたらこのメソッドを再び呼び出します
    $route: "fetchData"
  },

  methods: {
    fetchData() {
      console.log("login chack");
      var spotName = this.Form.spotName;
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          firebase
            .database()
            .ref("/application-" + spotName + "/reverse_dic/" + user.uid + "/")
            .once("value")
            .then(snapshot => {
              console.log(snapshot.val());
              if (snapshot.val() !== null) {
                this.aleady = true;
              }
            });
        } else {
          this.$router.push({
            name: "Signin"
          });
        }
      });
    },
    post: function() {
      if (this.loading) return;
      this.loading = true;
      if (this.intro_count > 120) {
        alert("紹介文が多いです");
        this.loading = false;
        return;
      } else if (this.body_count < 400) {
        alert("文章が少ないです");
        this.loading = false;
        return;
      } else if (this.body_count > 10000) {
        alert("文章が多いです");
        this.loading = false;
        return;
      } else if (
        this.Form.department === "" ||
        this.Form.name === "" ||
        this.Form.title === "" ||
        this.Form.intro === "" ||
        this.Form.body === ""
      ) {
        alert("かけていないところがあります。もう一度確認ください。");
        this.loading = false;
        return;
      }
      const application = firebase.functions().httpsCallable("application");
      application(this.Form)
        .then(result => {
          console.log(result.data);
          if (!result.data["login"]) {
            alert(
              "申し訳ございません、ログイン情報が切れましたのでもう一度ログインをお願いします。"
            );
            this.$router.push({
              name: "Signin"
            });
            this.loading = false;
            return;
          } else {
            this.posted = true;
          }
        })
        .catch(err => {
          alert("エラーが発生しました。再度時間をおいて後ほどお願いします。");
          this.error = true;
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    introChange: function() {
      this.intro_count = this.Form.intro.length;
    },
    bodyChange: function() {
      this.body_count = this.Form.body.length;
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  text-align: center;
}
.box {
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  max-width: 800px;
  font-size: large;
  height: min-content;
}

.textbox {
  margin-top: 20px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
.texts {
  width: 90%;
  margin: 10px;
  min-width: 200px;
  padding: 10px;
}
#intro {
  min-height: 100px;
}
#body {
  min-height: 300px;
}
textarea {
  min-width: 300px;
}
.tag {
  display: inline-block;
  margin-right: 20px;
}
#tag0 {
  color-interpolation-filters: red;
}
#label0 {
  color: red;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
}
.zyuuyou {
  color: red;
}
.counts {
  padding: 0px;
  margin: 0px;
  margin-top: -10px;
  padding-bottom: 10px;
}
button {
  min-width: 50px;
  min-height: 50px;
}
a {
  color: #42b983;
  cursor: pointer;
}
#back {
  margin-right: auto;
  margin-right: 80%;
  text-align: left;
}
.alert-color {
  background-color: rgba(255, 0, 0, 0.5);
}
</style>